<template>
  <div class="wrap-lg">
    <el-breadcrumb separator-class="el-icon-arrow-right" style="padding: 20px 0">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/mall' }">日化商城</el-breadcrumb-item>
      <el-breadcrumb-item>{{goods.name}}</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row :gutter="20">
        <el-col :span="10" style="text-align: center;padding-top: 40px;">
          <img :src="goods.image" style="width: 80%"/>
        </el-col>
        <el-col :span="14" style="padding-left: 50px;min-height: 300px;">
          <h2>{{goods.name}}</h2>
          <p>产品型号：<span>{{goods.code}}</span></p>
          <p>产品规格：<span>{{goods.specification}}</span></p>
          <p>产品价格：
            <span v-if="goods.price>0">{{goods.price}}元</span>
            <span v-else>面议</span>
          </p>
          <p v-for="item in goods.goodsClassiResponseList" :key="item.id">
            {{item.classificationName}}:
            <span v-for="(subItem) in item.goodsCategoryResponseList" :key="subItem.id">
              <span style="margin-right: 10px;margin-left: 10px">{{subItem.categoryName}}</span>
            </span>
          </p>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <h3>产品介绍：</h3>
      <div v-html="goods.description"></div>
    </el-card>
  </div>
</template>

<script>
import { getInfo } from '@/api/mall/goods'

export default {
  name: 'detail',
  data () {
    return {
      goodsId: null,
      goodsclassif: this.commonUtils.sessionStorageGet('goodsclassif'),
      goods: {}
    }
  },
  mounted () {
    this.goodsId = this.$route.query.sid
    this.getInfo()
  },
  filters: {
    filtersCategory: function (val) {
    }
  },
  methods: {
    toPage (path) {
      this.$router.push({
        name: path,
        service: {}
      })
    },
    getInfo () {
      let param = {}
      param.id = this.goodsId
      getInfo(param).then(res => {
        this.loading = false
        var result = res.data
        if (result.rtnCode !== '0') {
          this.$message({
            type: 'info',
            message: result.msg
          })
        } else {
          this.goods = result.bizData
        }
      }).catch(ex => {
        this.loading = false
        this.$message.error('列表加载失败，请稍后再试！')
      })
    }
  }
}
</script>

<style scoped>
  h4{
    border-left: solid 6px #32A08C;
    padding-left: 10px;
  }
</style>
